import { render } from "./Iimmpact.vue?vue&type=template&id=69d5d3e1&scoped=true"
import script from "./Iimmpact.vue?vue&type=script&lang=js"
export * from "./Iimmpact.vue?vue&type=script&lang=js"

import "./Iimmpact.vue?vue&type=style&index=0&id=69d5d3e1&lang=scss"
import "./Iimmpact.vue?vue&type=style&index=1&id=69d5d3e1&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d5d3e1"]])

export default __exports__